// export const API = "https://api.kamanfg.ir/api/";
// export const IMAGE_API = "https://api.kamanfg.ir/";
// export const BLOG_API = "https://api.kamanfg.ir/blog/api/";
// STG
// export const API = "http://stg.apikf.jibman.ir/api/";
// export const IMAGE_API = "http://stg.apikf.jibman.ir";
// export const BLOG_API = "http://stg.apikf.jibman.ir/blog/api/";

export const API = process.env.VUE_APP_API;
export const IMAGE_API = process.env.VUE_APP_IMAGE_API;
export const BLOG_API = process.env.VUE_APP_BLOG_API;

export const REGISTER = `${API}account/register`;

export const LOGIN = `${API}account/login`;

export const ACCOUNT_CAPTCHA = (payload) =>
  `${API}account/captcha/${payload.height}/${payload.width}/${payload.red}/${payload.green}/${payload.blue}/${payload.type}`;

export const REVOKE_TOKEN = `${API}account/revoke-access-token`;

export const POST_USER_INFO = `${API}user-info`;
export const POST_FINANCIAL_INFO = `${API}user-info/financial`;

export const UPDATE_FINANCIAL_INFO = `${API}user-info/financial`;

export const SET_DEFAULT_FINANCIAL = (financialInfoId) =>
  `${API}user-info/financial-set-default/${financialInfoId}`;

export const POST_CONTACT_INFO = `${API}user-contact-info`;

export const GET_USER_INFO = `${API}user-info`;

export const GET_USER_CONTACT_INFO = `${API}user-contact-info`;

export const GET_USER_FINANCIAL_INFO = `${API}user-info/financial`;

export const SEND_REGISTER_OTP = `${API}account/send-register-otp`;

export const RESEND_REGISTER_OTP = `${API}account/resend-register-otp`;

export const SEND_LOGIN_OTP = `${API}account/send-login-otp`;

export const GET_USER_SETTINGS = `${API}user-settings`;

// export const CHANGE_USER_SETTINGS = ({
//   key,
//   value
// }) => `${API}user-settings?key=${key}&value=${value}`

export const CHANGE_USER_SETTINGS = ({ key, value }) => `${API}user-settings`;

export const SEND_ACTION_OTP = `${API}sms-action-confirmation/send`;

export const CONFIRM_REGISTER_OTP = `${API}account/confirm-register-otp`;

export const CONFIRM_LOGIN_OTP = `${API}account/confirm-login-otp`;

export const GET_QUIZ = (userId) => `${API}quiz?userId=${userId}`;

export const GET_QUIZ_DETAILS = ({ quizId, pageNumber, pageSize }) =>
  `${API}quiz/quiz-detail?quizId=${quizId}&pageNumber=${pageNumber}&pageSize=${pageSize}`;

export const POST_QUIZ = `${API}quiz`;

export const SET_NEW_PASSWORD = `${API}manage-account/set-new-password`;

export const SET_USER_PASSWORD_AND_BASIC_INFO = `${API}account/verify-registeration`;

export const RESET_PASSWORD_OTP = `${API}account/reset-password-otp`;

export const RESET_PASSWORD_CONFIRM_OTP = `${API}account/reset-password-confirm-otp`;

export const RESEND_RESET_PASSWORD_OTP = `${API}account/resend-reset-password-otp`;

export const RESEND_TWO_FACTOR_SMS = `${API}account/resend-two-factor-sms`;

export const RESET_PASSWORD = `${API}account/reset-password`;

export const SEND_CHANGE_PASSWORD_OTP = `${API}manage-account/send-change-password-otp`;

export const CHANGE_PASSWORD = `${API}manage-account/change-password`;

export const GET_SUGGESTED_PLAN_DETAILS = (quizId) =>
  `${API}suggested-plans-details?quizId=${quizId}`;

export const GET_PLAN = (slug) => `${API}plan-by-slug?slug=${slug}`;

export const GET_PROVINCE_LIST = `${API}application-basic-data/provinces`;

export const GET_BANK_LIST = `${API}application-basic-data/banks`;

export const GET_CITY_LIST = (provinceId) =>
  `${API}application-basic-data/cities/${provinceId}`;

export const CITIES_AUTOCOMPLETE = (payload) =>
  `${API}application-basic-data/cities-autocomplete?cityName=${payload.cityName}`;

export const GET_ACCOUNT_INFO = `${API}manage-account/account-info`;

export const GET_USER_DOCUMENTS = `${API}user-document`;

export const GET_IMAGE = (path) => `${IMAGE_API}image/${path}`;

export const FINISH_REGISTRATION = `${API}manage-account/finish-user-registration`;

export const CHECK_USER_REGISTRATION_DATA = `${API}manage-account/check-user-registration-data`;

export const REQUEST_PORTFOLIO = `${API}portfolio`;

export const CONTACT_US = `${API}contact-us`;

export const GET_CAPTCHA = (payload) =>
  `${API}sejam/captcha/${payload.height}/${payload.width}/${payload.red}/${payload.green}/${payload.blue}`;

export const SEND_SEJAM_OTP = `${API}sejam/send-otp`;

export const SEJAM_SAVE_PROFILE = `${API}sejam/save-profile`;

export const ALL_FUNDS = `${API}rayan-fund/all-funds`;

export const CUSTOMER_ORDERS = (
  payload,
) => `${API}rayan-fund/customer-order?pageNumber=${payload.pageNumber}&pageSize=${payload.pageSize}&fundId=${payload.fundId}
&startDate=${payload.startDate}&endDate=${payload.endDate}&type=${payload.type}`;

export const SIX_MONTH_CUSTOMER_ORDERS = (
  payload,
) => `${API}rayan-fund/customer-order?pageNumber=${payload.pageNumber}&pageSize=${payload.pageSize}&fundId=${payload.fundId}
&startDate=${payload.startDate}`;

export const WITHDRAW = `${API}rayan-fund/fund-withdraw`;

export const ONLINE_PAYMENT = `${API}rayan-fund/online-payment`;

export const GET_FUND = (fundId) => `${API}rayan-fund/${fundId}`;

export const FUND_HISTORY = (payload) =>
  `${API}rayan-fund/history?fundId=${payload.fundId}&numberOfMonth=${payload.numberOfMonth}`;

export const GET_PROFIT = (fundId) =>
  `${API}rayan-fund/fund-statistics?fundId=${fundId}`;

export const MY_FUND_INFO = (fundId, forceUpdate) =>
  `${API}rayan-fund/my-fund-info/${fundId}?forceUpdate=${forceUpdate}`;

export const TRANSACTION_HISTORY = (
  payload,
) => `${API}rayan-fund/customer-transaction-history?pageNumber=${payload.pageNumber}&pageSize=${payload.pageSize}&fundId=${payload.fundId}
&startDate=${payload.startDate}&endDate=${payload.endDate}&type=${payload.type}`;

export const ONE_MONTH_TRANSACTION_HISTORY = (
  payload,
) => `${API}rayan-fund/customer-transaction-history?pageNumber=${payload.pageNumber}&pageSize=${payload.pageSize}&fundId=${payload.fundId}
`;

export const FUND_BANK_ACCOUNTS = (fundId) =>
  `${API}rayan-fund/fund-bank-accounts?fundId=${fundId}`;

export const OFFLINE_PAYMENT = `${API}rayan-fund/offline-payment`;

export const GET_ANNOUNCEMENTS = (payload) =>
  `${API}announcement?PageNumber=${payload.pageNumber}&PageSize=${payload.pageSize}`;

export const GET_USER_ACTION_LOG = (payload) =>
  `${API}user-action-log?PageNumber=${payload.pageNumber}&PageSize=${payload.pageSize}`;

export const GET_USER_TICKET = (payload) =>
  `${API}ticket?PageNumber=${payload.pageNumber}&PageSize=${
    payload.pageSize
  }&title=${payload.title}${
    payload.categoryId ? "&categoryId=" + payload.categoryId : ""
  }`;

export const GET_CUSTOMER_BANKS = (fundId) =>
  `${API}rayan-fund/customer-banks?fundId=${fundId}`;

export const REMOVE_DOCUMENT = (documentType) =>
  `${API}user-document/${documentType}`;

export const GET_TICKET = (ticketId) => `${API}ticket/${ticketId}`;

export const SEND_TICKET = `${API}ticket`;

export const SEND_TICKET_RESPONSE = `${API}ticket/response`;

export const SEND_TICKET_REPLY_RESPONSE = (payload) =>
  `${API}ticket/response?body=${payload.body}&ticketId=${payload.ticketId}&replayResponseId=${payload.replayResponseId}`;

export const GET_TICKET_CATEGORIES = () => `${API}ticket/categories`;

export const GET_TICKET_FILE = (payload) => `${payload.path}`;

export const GET_USER_ALL_INFO = (userId) =>
  `${API}user-info/user-all-info?userId=${userId}`;

export const GET_LICENSE_CAPTCHA = (payload) =>
  `${API}user-info/license-agreement/captcha/${payload.height}/${payload.width}/${payload.red}/${payload.green}/${payload.blue}`;

export const LICENSE_OTP = `${API}user-info/license-agreement-otp`;

export const CONFIRM_LICENSE_OTP = `${API}user-info/confirm-license-agreement-otp`;

export const GET_USER_REGISTERED_FUNDS = `${API}rayan-fund/user-registered-funds-info`;

export const RETRY_REGISTER_FUND = `${API}rayan-fund/retry-register-in-fund`;

export const GET_POSTS_BY_CATEGORY = ({
  categoryId,
  pageNumber,
  pageSize,
  sortDesc,
}) =>
  `${BLOG_API}posts-by-category?categoryId=${categoryId}&PageNumber=${pageNumber}&PageSize=${pageSize}&sortDesc=${sortDesc}`;

export const GET_POST_BY_ID = ({ postId }) =>
  `${BLOG_API}post?postId=${postId}`;

export const CHANGE_PROFIT_TYPE = `${API}rayan-fund/change-profit-type`;

export const TWRR_CHART_DATA = (numberOfDate, periodicity) =>
  `${API}portfolio/twrr-chart?numberOfDate=${numberOfDate}&periodicity=${periodicity}`;

export const FUND_COMPOSITION = (fundId) =>
  `${API}rayan-fund/fund-composition?fundId=${fundId}`;

export const SEND_CHANGE_ACCOUNT_SECURITY_OTP = `${API}user-settings/edit-twoFA`;

export const CHANGE_SECURITY_STATUS = `${API}user-settings/confirm-twoFA`;

export const LOG_OUT = `${API}account/logout`;

export const GET_CURRENT_SESSIONS = `${API}account/current-active-session`;

export const GET_OTHER_SESSIONS = `${API}account/other-active-sessions`;

export const GET_SESSION_INFO = `${API}account/check`;

export const TERMINATE_OTHER_SESSIONS = `${API}account/terminate-all-sessions`;

export const FEATURE_FLAG = `${API}featureflags`;

export const EDIT_PROFILE = `${API}sejam/edit-profile`;

export const SEND_OTP_REGISTER_BY_NATIONAL_ID = `${API}account/send-otp-register-by-nationalid`;

export const CONFIRM_OTP_REGISTER_BY_NATIONAL_ID = `${API}account/confirm-otp-register-by-nationalid`;

export const RESEND_OTP_REGISTER_BY_NATIONAL_ID = `${API}account/resend-otp-register-by-nationalid`;

export const RESEND_LOGIN_OTP = `${API}account/resend-login-otp`;

export const POST_CONSUME_GIFT_CARD = `${API}giftcard/consume`;

export const POST_RISK_ANSWERS = `${API}quiz/my-risk-assessment-answers`;

export const GET_RISK_Questions = `${API}quiz/risk-assessment-questions`;

export const GET_SUGGEST_PORTFOLIO = `${API}plan/personality-suggests`;
